<template>
    <div class="guest-details" id="party">
        <!-- <pre>openMainBookerState: {{openMainBookerState}}</pre>
<pre>openCompanionState: {{openCompanionState}}</pre>
<pre>isInsert: {{isInsert}}</pre>
<pre>companionIndex: {{companionIndex}}        </pre> -->
        <div
            id="mainBookerInfo"
            v-if="getMainBooker && !openMainBookerState && !openCompanionState"
        >
            <h2>{{ $t("Your party") }}</h2>
            <p>
                <strong>{{
                    $t(
                        "To continue with your booking we need to know some details about all members of your party. Please add them by clicking “add new companion” if they are not already listed here."
                    )
                }}</strong>
            </p>
            <h3 class="customer-title">
                {{ getMainBooker.Name }} {{ getMainBooker.LastName }}
                <a
                    href="#"
                    @click.prevent="editMainBooker"
                    style="float:right"
                    class="button blue btn-xs"
                    >{{ $t("Amend these details") }}</a
                >
            </h3>
            {{ $t("DOB") }}: <span>{{ getMainBooker.DOB }}</span> <br />
            {{ $t("Email") }}: <span>{{ getMainBooker.EMail }}</span> <br />
            {{ $t("Phone") }}: <span>{{ getMainBooker.Phone }}</span> <br />
            {{ $t("Address") }}:
            <span>
                {{ getMainBooker.House }}
                {{ getMainBooker.Street }}
                {{ getMainBooker.Locality }}
                {{ getMainBooker.Town }}
                {{ getMainBooker.County }}
                {{ getMainBooker.Country }}
                {{ getMainBooker.Postcode }}
            </span>
        </div>
        <SearchCustomer
            v-if="!getMainBooker || this.openMainBookerState"
            @saved="mainBookerSaved"
            :customer="getMainBooker"
            :isInsert="isInsert"
        >
            <h3>
                <span v-if="isInsert">{{ $t("Add") }}</span>
                <span v-else>{{ $t("Edit") }}</span>
                {{ $t("primary booker") }}
            </h3>
            <p>
                {{
                    $t(
                        "Please enter details of the primary booker, ie the person we'll write to with confirmation."
                    )
                }}
            </p>
        </SearchCustomer>

        <div class="getcompanions" v-if="!openMainBookerState">
            <div v-if="!openCompanionState">
                <div v-for="(companion, index) in getCompanions" :key="index">
                    <h3 class="customer-title">
                        {{ companion.Name }} {{ companion.LastName }}
                        <a
                            href="#"
                            @click.prevent="deleteCompanion(index)"
                            class="button btn-xs"
                            style="background:#f33;color:white;float:right;margin-left:10px"
                            >X</a
                        >
                        <a
                            href="#"
                            @click.prevent="editCompanion(index)"
                            class="button blue btn-xs"
                            style="float:right"
                            >{{ $t("Amend these details") }}</a
                        >
                    </h3>
                    {{ $t("DOB") }}: <span>{{ companion.DOB }}</span> <br />
                    {{ $t("Email") }}: <span>{{ companion.EMail }}</span> <br />
                    {{ $t("Phone") }}: <span>{{ companion.Phone }}</span> <br />
                    {{ $t("Address") }}:
                    <span>
                        {{ companion.House }}
                        {{ companion.Street }}
                        {{ companion.Locality }}
                        {{ companion.Town }}
                        {{ companion.County }}
                        {{ companion.Country }}
                        {{ companion.Postcode }}
                    </span>
                </div>
            </div>

            <SearchCustomer
                v-if="getMainBooker && this.openCompanionState"
                @saved="companionSaved"
                @cancelled="companionCancelled"
                :customer="getCompanions[companionIndex]"
                :isMainBooker="false"
                :isInsert="isInsert"
                :canCancel="isInsert"
            >
                <h3>
                    <span v-if="isInsert">{{ $t("Add") }}</span>
                    <span v-else>{{ $t("Edit") }}</span>
                    {{ $t("companion") }}
                </h3>
                <p>{{ $t("Please enter details for the companion.") }}</p>
            </SearchCustomer>
            <div
                v-if="
                    getMainBooker &&
                        !openCompanionState &&
                        getSuggestedCompanions.length
                "
                class="suggested-companions"
            >
                <h4>{{ $t("Add a previous companion") }}:</h4>
                <a
                    v-for="(sc, index) in getSuggestedCompanions"
                    :key="sc.Id"
                    href="#"
                    class="button blue btn-sm suggested-companion"
                    @click.prevent="addSuggestedCompanion(index)"
                    >+ {{ sc.Name }} {{ sc.LastName }}</a
                >
            </div>
            <h3 class="add">
                <a
                    href="#"
                    class="button blue btn-sm"
                    v-if="getMainBooker && !openCompanionState"
                    @click.prevent="addCompanion"
                    >{{ $t("Add new companion") }}</a
                >
            </h3>
        </div>
        <div
            v-if="getMainBooker && !openMainBookerState && !openCompanionState"
            class="continue_button"
        >
            <p>
                {{
                    $t(
                        "When you have added all members of your party, please click “Continue”"
                    )
                }}
            </p>
            <h3 class="add">
                <a href="#" class="button blue" v-if="false">Phone me</a> &nbsp;
                <a
                    href="#"
                    class="button blue"
                    @click.prevent="continueToVehicles"
                    >{{ $t("Continue") }} &gt;&gt;</a
                >
            </h3>
        </div>
    </div>
</template>
<script>
// @ is an alias to /src
import SearchCustomer from "@/components/SearchCustomer.vue";
import { mapGetters } from "vuex";

export default {
    name: "GuestDetails",
    components: {
        SearchCustomer
    },
    data() {
        return {
            openMainBookerState: false,
            openCompanionState: false,
            isInsert: true,
            companionIndex: null
        };
    },
    methods: {
        editMainBooker() {
            this.isInsert = false;
            this.openMainBookerState = true;
        },
        scrollToTop() {
            var elmnt = document.getElementById("party");
            setTimeout(function() {
                elmnt.scrollIntoView();
                // console.log('elmnt',elmnt);
            }, 10);
            // console.log('elmnt2',elmnt);
        },

        mainBookerSaved(value) {
            this.$store.commit("UPDATE_MAIN_BOOKER", value);
            this.openMainBookerState = false;
            this.isInsert = true;
            // console.log('mainBookerSaved');
            this.scrollToTop();
        },
        addCompanion() {
            this.openCompanionState = true;
            this.isInsert = true;
        },
        editCompanion(index) {
            this.companionIndex = index;
            this.openCompanionState = true;
            this.isInsert = false;
        },
        companionSaved(value) {
            if (this.isInsert) {
                this.$store.commit("INSERT_COMPANION", value);
            }
            this.openCompanionState = false;
            // console.log('companionSaved');
            this.scrollToTop();
        },
        companionCancelled() {
            this.openCompanionState = false;
            this.isInsert = true;
            this.companionIndex = null;
            this.scrollToTop();
        },
        deleteCompanion(index) {
            this.$store.commit("DELETE_COMPANION", index);
        },
        ISO2Uk(d) {
            return (
                d.split("-")[2] + "/" + d.split("-")[1] + "/" + d.split("-")[0]
            );
        },
        addSuggestedCompanion(index) {
            const sc = this.getSuggestedCompanions[index];
            this.$store.commit("INSERT_COMPANION", {
                Id: sc.Id,
                TitleID: sc.TitleID || "",
                gender: sc.gender || "",
                Name: sc.Name,
                LastName: sc.LastName,
                DOB: sc.DOB ? this.ISO2Uk(sc.DOB) : "",
                Postcode: "",
                House: "",
                Street: "",
                Town: "",
                Locality: "",
                County: "",
                Country: "",
                PassportCountry: sc.PassportCountry || "",
                EMail: "",
                Phone: "",
                PhoneWork: "",
                PhoneMob: ""
            });
            this.$store.commit("REMOVE_SUGGESTED_COMPANION", index);
        },
        continueToVehicles() {
            const currency = this.getCurrency.currency;
            const country = (this.getMainBooker.Country || "").trim();
            const isUK = country === "United Kingdom";
            const isBlank = country === "";

            // Guest Details now sits AFTER the priced steps, so changing
            // currency here must clear those choices and re-walk them.
            // The extra sentence in the popup text warns about that.

            // Rule 1: Booking in GBP but customer is NOT UK and NOT blank
            if (currency === "GBP" && !isUK && !isBlank) {
                this.$swal({
                    title: "",
                    text:
                        this.$t(
                            "You are booking in sterling, but not based in the UK: are you sure?"
                        ) +
                        " " +
                        this.$t(
                            "Switching currency will clear your extras, travel, insurance and discount choices, and you will need to make them again. Do you want to continue?"
                        ),
                    showCancelButton: true,
                    confirmButtonText: this.$t("Yes, continue in £"),
                    confirmButtonColor: "#00b8d3",
                    cancelButtonText: this.$t("No, please change to Euros"),
                    cancelButtonColor: "#00b8d3"
                }).then(result => {
                    if (result.isConfirmed) {
                        this.$router.push({
                            name: "Vehicles",
                            hash: "#appTop"
                        });
                    } else if (
                        result.dismiss === this.$swal.DismissReason.cancel
                    ) {
                        this.switchCurrencyAndRewalk("EUR");
                    }
                });
                return;
            }

            // Rule 2: Booking in EUR but customer IS UK or blank
            if (currency === "EUR" && (isUK || isBlank)) {
                this.$swal({
                    title: "",
                    text:
                        this.$t(
                            "Are you sure you want to book in Euros? You will not be able to book ferries through us, and you will not be able to convert the booking to sterling later."
                        ) +
                        " " +
                        this.$t(
                            "Switching currency will clear your extras, travel, insurance and discount choices, and you will need to make them again. Do you want to continue?"
                        ),
                    showCancelButton: true,
                    confirmButtonText: this.$t("Yes, continue in €"),
                    confirmButtonColor: "#00b8d3",
                    cancelButtonText: this.$t("No, please change to sterling"),
                    cancelButtonColor: "#00b8d3"
                }).then(result => {
                    if (result.isConfirmed) {
                        this.$router.push({
                            name: "Vehicles",
                            hash: "#appTop"
                        });
                    } else if (
                        result.dismiss === this.$swal.DismissReason.cancel
                    ) {
                        this.switchCurrencyAndRewalk("GBP");
                    }
                });
                return;
            }

            // No mismatch — proceed normally
            this.$router.push({ name: "Vehicles", hash: "#appTop" });
        },
        switchCurrencyAndRewalk(newCurrency) {
            // extras/ferries/insurance/discounts were chosen in the old
            // currency — clear them and send the customer back through the
            // priced steps (their guest details stay in the store)
            this.$store.commit("RESET_CURRENCY_CHOICES");
            this.$store.commit("UPDATE_CURRENCY", newCurrency);
            this.$store.commit("SWAP_ACCOMMODATION_PRICE");
            this.$store.commit("SWAP_AVAILABILITY_PRICES");
            this.$store.commit("CHANGE_PROGRESS_STEP", 1);
            this.$router.push({ name: "Extras", hash: "#appTop" });
        }
    },
    computed: {
        ...mapGetters([
            "getMainBooker",
            "getCompanions",
            "getCurrency",
            "getSuggestedCompanions"
        ])
    }
};
</script>

<style scoped>
.suggested-companions {
    margin: 15px 0;
}
.suggested-companion {
    margin: 0 8px 8px 0;
    display: inline-block;
}
</style>
